module.exports = __webpack_public_path__ + "static/avatar-c7795fb145b11dbc0f2fbe966229f6de.png";